// Tap a stat button -> pick a player -> stat recorded for the active team (picker can switch teams).
export const SCORING_BTNS = [
  { key: 'pts_2m', label: '2pt', tone: 'made' },
  { key: 'pts_2x', label: '2pt', tone: 'miss' },
  { key: 'pts_3m', label: '3pt', tone: 'made' },
  { key: 'pts_3x', label: '3pt', tone: 'miss' },
  { key: 'ft_m',   label: '1pt', tone: 'made' },
  { key: 'ft_x',   label: '1pt', tone: 'miss' },
];

export const ACTION_BTNS = [
  { key: 'reb_def', label: 'def', sub: 'reb' },
  { key: 'reb_off', label: 'off', sub: 'reb' },
  { key: 'to',      label: 'to',  sub: '' },
  { key: 'stl',     label: 'stl', sub: '' },
  { key: 'ast',     label: 'asst', sub: '' },
  { key: 'blk',     label: 'blk', sub: '' },
];

export const STAT_LABEL = {
  pts_2m: '2pt',  pts_2x: '2pt miss',
  pts_3m: '3pt',  pts_3x: '3pt miss',
  ft_m:   '1pt',  ft_x:   '1pt miss',
  reb_def: 'def reb', reb_off: 'off reb',
  to: 'turnover', stl: 'steal', ast: 'assist', blk: 'block', foul: 'foul',
};

// Stat groups offered in the Edit Play modal.
export const EDIT_STAT_GROUPS = [
  {
    label: 'Scoring',
    items: [
      { key: 'pts_2m', label: '2pt made', tone: 'made' },
      { key: 'pts_2x', label: '2pt miss', tone: 'miss' },
      { key: 'pts_3m', label: '3pt made', tone: 'made' },
      { key: 'pts_3x', label: '3pt miss', tone: 'miss' },
      { key: 'ft_m',   label: '1pt made', tone: 'made' },
      { key: 'ft_x',   label: '1pt miss', tone: 'miss' },
    ],
  },
  {
    label: 'Actions',
    items: [
      { key: 'reb_def', label: 'def reb', tone: 'action' },
      { key: 'reb_off', label: 'off reb', tone: 'action' },
      { key: 'ast',     label: 'assist',  tone: 'action' },
      { key: 'stl',     label: 'steal',   tone: 'action' },
      { key: 'blk',     label: 'block',   tone: 'action' },
      { key: 'to',      label: 'turnover', tone: 'action' },
      { key: 'foul',    label: 'foul',    tone: 'action' },
    ],
  },
];

// Feed shows only the last 7 plays.
export const FEED_MAX = 7;

// stat_type -> boxscore field, used for "block (2)" running totals in the feed.
export const STAT_TO_BOX_FIELD = {
  reb_def: 'dreb',
  reb_off: 'oreb',
  ast: 'ast',
  blk: 'blk',
  stl: 'stl',
  to: 'to',
  foul: 'foul',
};

export const SCORING_VALUES = { pts_2m: 2, pts_3m: 3, ft_m: 1 };

export const MADE_STATS = ['pts_2m', 'pts_3m', 'ft_m'];
export const MISS_STATS = ['pts_2x', 'pts_3x', 'ft_x'];
